import { render } from "./shipinhaoaccount.vue?vue&type=template&id=525371ce&scoped=true"
import script from "./shipinhaoaccount.vue?vue&type=script&lang=js"
export * from "./shipinhaoaccount.vue?vue&type=script&lang=js"

import "./shipinhaoaccount.vue?vue&type=style&index=0&id=525371ce&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-525371ce"]])

export default __exports__